import HomePage from "../components/HomePage";
import ManageCardSchemes from "../components/CardSchemes";
import ManageCardTypes from "../components/CardTypes";
import ManageConfigs from "../components/Configs";
import ManageCardIssuers from "../components/CardIssuers";
import ManageIdTypes from "../components/IdTypes";
import ManageDomains from "../components/Domains";
import ManageInstitutions from "../components/Institutions";
import ManageClients from "../components/Clients";
import ManageCurrencies from "../components/Currencies";
import CardStatus from "../components/StatusViews/CardStatus";
import WalletStatus from "../components/StatusViews/WalletStatus";

import {
  MdSettings,
  MdCardMembership,
  MdAssignmentInd,
  MdContactMail,
  MdPublic,
  MdPeople,
  MdMonetizationOn,
  MdDomain,
  MdAccountBalanceWallet,
  MdCreditCard,
  MdDoneAll
} from "react-icons/md";

// import NotFound from "../components/NotFound";

export const routeConstants = {
  HOMEPAGE: {
    key: "home",
    title: "Home",
    exact: true,
    name: "Home",
    path: "/",
    menu: false,
    pageComponent: HomePage,
    enabled: true
  },
  WALLETSTATUS: {
    key: "walletStatus",
    title: "Wallet Status",
    name: "WalletStatus",
    path: "/wallet-status",
    icon: MdAccountBalanceWallet,
    menu: true,
    menuOptions: {
      darken: true
    },
    pageComponent: WalletStatus,
    enabled: true
  },
  CARDSTATUS: {
    key: "cardStatus",
    title: "Card Status",
    name: "CardStatus",
    path: "/card-status",
    icon: MdDoneAll,
    menu: true,
    menuOptions: {
      darken: true
    },
    pageComponent: CardStatus,
    enabled: true
  },
  CARDSCHEMES: {
    key: "cardschemes",
    title: "Card Schemes",
    name: "ManageCardSchemes",
    path: "/card-schemes",
    icon: MdCreditCard,
    menu: true,
    pageComponent: ManageCardSchemes,
    enabled: false
  },
  CARDISSUERS: {
    key: "cardissuers",
    title: "Card Issuers",
    name: "ManageCardIssuers",
    path: "/card-issuers",
    icon: MdAssignmentInd,
    menu: true,
    pageComponent: ManageCardIssuers,
    enabled: true
  },
  CARDTYPES: {
    key: "cardtypes",
    title: "Card Types",
    name: "ManageCardTypes",
    path: "/card-types",
    icon: MdCardMembership,
    menu: true,
    pageComponent: ManageCardTypes,
    enabled: true
  },
  DOMAINS: {
    key: "domains",
    title: "Domains",
    name: "ManageDomains",
    path: "/domains",
    icon: MdPublic,
    menu: true,
    pageComponent: ManageDomains,
    enabled: true
  },
  CLIENTS: {
    key: "clients",
    title: "Clients",
    name: "ManageClients",
    path: "/clients",
    icon: MdPeople,
    menu: true,
    pageComponent: ManageClients,
    enabled: true
  },
  CURRENCIES: {
    key: "currencies",
    title: "Currencies",
    name: "ManageCurrencies",
    path: "/currencies",
    icon: MdMonetizationOn,
    menu: true,
    pageComponent: ManageCurrencies,
    enabled: true
  },
  CONFIGS: {
    key: "configs",
    title: "Configurations",
    name: "ManageConfigs",
    path: "/configurations",
    icon: MdSettings,
    menu: true,
    pageComponent: ManageConfigs,
    enabled: true
  },
  IDTYPES: {
    key: "idtypes",
    title: "Identification Types",
    name: "ManageIdTypes",
    path: "/identification-types",
    icon: MdContactMail,
    menu: true,
    pageComponent: ManageIdTypes,
    enabled: true
  },
  INSTITUTIONS: {
    key: "institutions",
    title: "Institutions",
    name: "ManageInstitutions",
    path: "/institutions",
    icon: MdDomain,
    menu: true,
    pageComponent: ManageInstitutions,
    enabled: true
  },
  NOTFOUND_ROUTE: {
    key: "pagenotfound",
    name: "PageNotFound",
    path: "*",
    exact: true,
    menu: false,
    pageComponent: HomePage,
    enabled: true
  }
};

export const createRoutes = () => {
  const routes = [];
  for (var route in routeConstants) {
    routeConstants[route].enabled && routes.push(routeConstants[route]);
  }
  return routes;
};

export const routes = createRoutes();
